(() => {
  function initialize(root) {
    root.querySelectorAll('[data-naxos-contact-fields]').forEach((fields) => {
      if (fields.dataset.initialized) return;
      const form = fields.closest('form');
      const answer = fields.querySelector('[data-math-answer]');
      const question = fields.querySelector('[data-math-question]');
      const error = fields.querySelector('[data-math-error]');
      const refresh = fields.querySelector('[data-math-refresh]');
      if (!form || !answer || !question || !error || !refresh) return;
      const requiredText = [...fields.querySelectorAll('[data-required-message]')];
      let expectedAnswer;
      let showError = false;

      function validateText(input) {
        input.setCustomValidity(input.value.trim() ? '' : input.dataset.requiredMessage);
      }

      function validateAnswer() {
        const value = answer.value.trim();
        const correct = /^[0-9]+$/.test(value) && Number(value) === expectedAnswer;
        const message = value ? window.NaxosText("naxos_ui.challenge_incorrect") : window.NaxosText("naxos_ui.challenge_required");
        answer.setCustomValidity(correct ? '' : message);
        error.hidden = correct || !showError;
        error.textContent = error.hidden ? '' : message;
        if (!error.hidden) answer.setAttribute('aria-invalid', 'true');
        else answer.removeAttribute('aria-invalid');
        return correct;
      }

      function newQuestion() {
        let left = 1 + Math.floor(Math.random() * 9);
        const right = 1 + Math.floor(Math.random() * 9);
        const subtract = Math.random() < 0.5;
        if (subtract) left += right;
        let prompt = `${left} ${subtract ? '−' : '+'} ${right} = ?`;
        // Make the refresh action visibly change the question, even after a random repeat.
        if (prompt === question.textContent) {
          left += 1;
          prompt = `${left} ${subtract ? '−' : '+'} ${right} = ?`;
        }
        expectedAnswer = subtract ? left - right : left + right;
        question.textContent = prompt;
        answer.value = '';
        showError = false;
        validateAnswer();
      }

      requiredText.forEach((input) => {
        input.addEventListener('input', () => validateText(input));
        input.addEventListener('change', () => validateText(input));
      });
      answer.addEventListener('input', validateAnswer);
      answer.addEventListener('change', validateAnswer);
      answer.addEventListener('invalid', () => {
        showError = true;
        validateAnswer();
      });
      refresh.addEventListener('click', () => {
        newQuestion();
        answer.focus();
      });
      form.addEventListener('submit', (event) => {
        requiredText.forEach(validateText);
        showError = true;
        validateAnswer();
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
        }
      }, true);
      form.addEventListener('reset', () => {
        window.setTimeout(() => {
          requiredText.forEach((input) => input.setCustomValidity(''));
          newQuestion();
        }, 0);
      });

      newQuestion();
      fields.dataset.initialized = 'true';
      fields.disabled = false;
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
